import { GisSearchRequest } from './gis.search.request';

export class GisOrderHistorySearchRequest extends GisSearchRequest {
  Ordernumber: number;
  Reference: string;
  Description: string;
  PlateNumber: string;
}
